import * as React from "react"
import { Button } from "gatsby-interface"
import { MdArrowForward } from "react-icons/md"
import { ui as uiText } from "@modules/locales/default.js"

export type ConnectCmsFormControlsProps = {
  isSubmitting: boolean
  onCancel: () => void
}

export function ConnectCmsFormControls({
  isSubmitting,
  onCancel,
}: ConnectCmsFormControlsProps) {
  return (
    <React.Fragment>
      <Button
        type="button"
        onClick={onCancel}
        tone="NEUTRAL"
        variant="SECONDARY"
      >
        {uiText.actions.cancel}
      </Button>
      <Button
        data-cy="cms-data-source-continue"
        type="submit"
        loading={isSubmitting}
        disabled={isSubmitting}
        tone="BRAND"
        variant="PRIMARY"
        rightIcon={<MdArrowForward />}
      >
        {uiText.actions.continue}
      </Button>
    </React.Fragment>
  )
}
